<template>
    <div class="internet-content">
        <div class="internet-banner">
            <div class="w-1500-c">
                <div class="banner-text">
                    <p class="s-title">沧州工业互联网综合服务平台</p>
                    <p class="title">让工业更有智慧</p>
                    <p class="line"></p>

                    <!-- <p class="desc">以一个核心、两个建设、三个服务，以提高企业质量和效益为中心，</p> -->
                    <p class="desc">以推进制造业数字化、网络化、智能化为主线，</p>
                    <p class="desc">为企业数字化转型和向高质量发展提供强有力的技术支撑。</p>
                </div>
            </div>
        </div>

        <div class="internet-one">
            <div class="w-1200-c">
                <div class="common-top">
                    <p class="common-title">工业物联网平台</p>
                    <p class="common-desc">快速设备接入、覆盖云、管、边、端各环节，满足企业的需求</p>
                    <!-- <p class="common-btn" @click="toUrl('/industIot')">查看更多</p> -->
                    <router-link to="/industIot" target="_blank">
                        <p class="common-btn">查看更多</p>
                    </router-link>
                </div>
                <div class="internet-one-image">
                    <div>
                        <div>
                            <div
                                class="itp-warp-item item-absot1"
                                style="opacity: 1; transform: translate(0px, 0px);"
                            >
                                <div class="itp-warp-animat"></div>
                                <div class="itp-warp-content">
                                    <div class="itp-warp-item-img">
                                        <img
                                            class="itpImg"
                                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAACxklEQVRIS63WTYjVVRjH8c84FVgyLRplIhiLxHAoUaGF9AKFRKQ0OmOKoIPhRoM2LgaKLChcCFERk7gqKATNNKxFi1lcmMJFEGKgi0EFN4JCzjBJYaZXnsu58J/L/+0yntW95+X5Pm/nd/49ikezYKmn5EzR0gacwT9lhwP4Ba4lK5vwAroBLsKdjBcfVAF7cTcd2IbjXQJPYmRubs7o6KjJyclCb5/C5Q7jS3G9S+APGA3g8PCwRqNRCHwL3+cYjzQ/gas169iZ0vF2Sp/F6/gspfAQxguAO3E0AQP8eKptNEXnuIin8RJ+x38B/Aa7Mzsfwc94tQD4Nfbgf0SN/8JjuIQVyc4SbMQxvIbJtv0ANsfGxkxMTOjr64v5X/AiHsTiDpcjpVewPM0/ijlsxYmcCM9hTXa+BRwaGjI1NaW/vz/WvsUYfkupyO7/A+tS2iO6ztHs7e01MzPTdv5vtKLIRrgZP+Yc/hz7M/P7cDj9L7pOzYGBAdPT0wYHB83OzkZGonHmAdt/Iu83MZUia6Q6xvopbEl1iiYoAr6J0xn70QdhJxeYnW/LWty7f1PNPsSnIU8Vd3EZ9mICNzozV5garMXZdOBl/Jp+hzPPYDqnDJVTecDn8GeKIrr04dT6bWMBjHoeqbSesyEP+DbirpVFHyq0/X4Bv8I7JcAQ825ejOyNyD0YEvR8idEQ9RD3eLrqjCcRV6/lZJ6ntzGLeB3yxkG830WUodGhXoXAaIrY8EYBMMT7uxxgCP8rqbvbYhKQWsBPEPcubzyAyEJndkKt2qnrGjiMn0oKFFkY6ZDEBQGrHtkAfoSPC5yqHeFDuFWjIQJ4HvFwV43SGq5Pn3NV9yy+xGLPvJeggFwKfBdf1ogwpC8ksMqx8KEUGI/vrhqGDqT6LRh4AavwXkVhVmNHjX1hZiVCn3MvftHnfVVj1FlvAe8Bi6qhC6+03TMAAAAASUVORK5CYII="
                                        />
                                        <span class="itpspan">数字化</span>
                                    </div>
                                    <div class="itp-warp-item-bg">
                                        <img />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div
                                class="itp-warp-item item-absot2"
                                style="opacity: 1; transform: translate(0px, 0px);"
                            >
                                <div class="itp-warp-animat"></div>
                                <div class="itp-warp-content">
                                    <div class="itp-warp-item-img">
                                        <img
                                            class="itpImg"
                                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAeCAYAAADQBxWhAAACmElEQVRIS9XWTchVdRAG8N9bEIoZvVgKhoEgJSFI5kJEXJgoUUshlBaBYNJGA5FARIxQRERtkxKSixKpTYsWpbQQcSFS5ELERYuotEz8oDT8KOWR/5FT7znnnluCNLt7/zPzzMczM2fEv5fbWI6Dw7oYGdagpv//B52MXzAPx/9DJWI6H8fwJC5UvtrKexGjmIjfG4Dz/3T8inMtgT2GK4ivSXWdrp6mZ+uwoxi8jg87Mn8fb9be12MbxmD0IVIVcfzdxBrsw40C8BL2Ylrt9xddbRkE+hxOFQdP4eyAHqfcT2A31rbpdoGOxzVcxaNDEOpzvIxX8UmTXUBDmEsNj3/ioaae9AjgezzdYjsa0Ot4BKtLb+JzIY4g5Q07q6D21wBX4q+OAELEQ1hadN7AnnAhoMnmB0zFC/imlDXlzXvoXs3YZ8XBs0X/8Q7QL7Gk+JiDrwsnptV7GvYFPJIo3ytMbfMbnTg93KIwBT9jQkninv82IsXh8/i2I5MFONrQt9k4WQt+DKG6QDOfv/UckX+qrcIHpWJvYVefjZRMQ6LTA0ATdDKpZBNmYga+K6Cv4eO+oO9iY1HO3GVxXy6/Q74V+KgjqMx2KpWRrOzuqreV91ZhdZynR229TWbvtAAfKEe+9+5dhk8RBp4vZfoJiwvAdrxS9u2PLaBpUYINIf8mg65MDJPtsHICc/Fw0wLpAq3mLLObldZXcs5y1jZgS5PRoCsTAmWB54xlyNPrLsnWyfapr78x+oNAY/AMzhTLnLlZDai5p5nNyNvleLcG1we0Mv4Ki1oY/wfGlf6HB50yDOjWkkWTTQXay18vpRL2AwXtKl2vJHopFZQXkcvSJZsH9TPvw4Dm47v6Cmjzfd9B83W3834Q8w5wzIIrOMGLswAAAABJRU5ErkJggg=="
                                        />
                                        <span class="itpspan">智能化</span>
                                    </div>
                                    <div class="itp-warp-item-bg">
                                        <img />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <div
                                class="itp-warp-item item-absot3"
                                style="opacity: 1; transform: translate(0px, 0px);"
                            >
                                <div class="itp-warp-animat"></div>
                                <div class="itp-warp-content">
                                    <div class="itp-warp-item-img">
                                        <img
                                            class="itpImg"
                                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAADBklEQVRIS43WScyfUxQG8F/NEdGExrCRVGhQFixopBbmoIaysUCbbkTSWNhg0SjpgpWIWIkYSgyJeWgQNTVpiIhUhZoSK3NUmooGJU9zr9ze/t/3/c7m/f7fPed57pnvPHOTK3E3Tpqh/jluw0tTUPMmFF7BZY3OZ3gHP+MonIuTm/NXsWwIc4jsIrxejF7Ecvw7crHgxLNKdDHe6PVnkT2KGzrFP3AJ3psKFX7BkXgC17X6PdnDWIl8VxXFW0u+ql28vhMn4mz8hke6cFfdx3F9/dGSXVhcb4naix2Nb3HogHdf4x48iZ3lAivwf0hbsuSkJn4sWn3ubsG9AwbBW4A9PJWsVt1UdX5Zwtdip+zj0ZDkchtwaQXPP57H1QMW++PvcnYT7sNB2IpTcTPuH7AN7lVxLGTpo3g25NXB+LMAHVby0eJ+jNNxFj6cQRjc3SHMH1tw2ghZzdFYiLdjPvYb6MdgbAtABfsGJ3Q3+6cATOUyZsHZgcNneJdwL65kNfapnoV4unxPwbH4YQ7NnNG1ERfgrU4/+VxdydbiXbzdKaUoDpwDUVXZVQqnj8QdWFvJHghz6fbHOvC5hLCaHIfvSlWnCqtsxpJKljWRkGVK9CF7uZRuKmpKliDAVZ7CtfVHyEKUPVU9SJmn3COZ3JmFVZLL9FgL2F5gbDNsDUEW4wtN2cZgHdY0KGn2B3HElGvd+bay7xKVZe0Eyd5Kvp4d6bmKdTzOwDE4AN+XDZBJ0soheAZX1AmSw+Qli+/TiQYfcux9LMUnZZrEk79KOhKpRG55P/UD9kW36qcil1Atwu3N3vsAZ+LXskj3mvoBPK80Y+bk5VMM5Tyb+5zSMlmUVbJMs8si55dm32f4JmfZrEMLtL1DNvlDuAtp2lbeLJMkT4xs/j0y9gb5qfTdLCczcDM3vyohbHV+LC+v9f1bZmg61CdCQJ7DNR3j72XgVvt8UwSpukh6M97tJVOj6LXyqqpGeTduwo34CNlv7cN1NN9TZJUkCzYv4mzlXnKBPA1CNCr/AU3QoFxaWv3DAAAAAElFTkSuQmCC"
                                        />
                                        <span class="itpspan">网络化</span>
                                    </div>
                                    <div class="itp-warp-item-bg">
                                        <img />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="internet-app">
            <div class="common-top app-top">
                <div class="w-1200-c">
                    <p class="common-title">场景驱动 应用落地</p>
                    <p class="common-desc">工业应用具有持续丰富的行业云应用，从生产监控到流程管理， 让企业在应对数字化改造时，极快上手，更具效率。</p>
                    <!-- <p class="common-btn" @click="toUrl('/softwareMarket/softwareHome')">查看更多应用</p> -->
                    <router-link to="/softwareMarket/softwareHome" target="_blank">
                        <p class="common-btn">查看更多应用</p>
                    </router-link>
                </div>
            </div>
            <div class="internet-app-warp">
                <div class="internet-app-item internet-app-item1">
                    <div class="internet-app-mark"></div>
                    <div class="internet-app-content">
                        <div class="internet-app-icon">
                            <img
                                src="data:image/png;base64,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"
                                alt
                            />
                            <p class="internet-icon-title">平台汇聚场景</p>
                        </div>
                        <div class="internet-app-text">
                            <div class="internet-text-title">平台汇聚场景</div>
                            <div class="internet-text-br"></div>
                            <div
                                class="internet-text-work"
                            >“双平台”聚焦制造业数字化升级工业互联网平台+标识解析为推进沧州工业互联网标准体系建设，沧州工业互联网规模化应用奠定基础。</div>
                        </div>
                    </div>
                </div>
                <div class="internet-app-item internet-app-item2">
                    <div class="internet-app-mark"></div>
                    <div class="internet-app-content">
                        <div class="internet-app-icon">
                            <img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFsAAABbCAYAAAAcNvmZAAAWp0lEQVR4Xu2dCbRkVXWG996n3msRxQRBhSiDA4EYGyO0QUEJoCAokwOKihFMBEGRWVCQIUiLUzNIRCPzJNCEVhSHNuAAUSSQKJAAKg6dRKNEiYp0d9U92/VV9n3rvvequm69qnqv6easVWt1r3er6tz/7rOHf//nlMpqNNxdReRxIjJPRMbj3xuKyPpFUawrIuuq6hNFZExEWu7eFJGHUkq/EpH/EZFfi8hKEVnBS1X592ozuLk5He4OsLyeXBTFX6jqC1R1K3d/jog8LYA1EanOtfpvF5Ecr0dU9cfufp+I3GNmd4jIf4jI7wL81lze7JyA7e5Y7bqtVmu+mb3c3f8KgMOamVMJIOA8pKoP5px/LyK/V9XfhlXPMzOs/YnujrWzAtYRkUY8GD6nAGhV/ba732RmN4nIf8bn8LdZHbMKtrsDzrNzzq8RkX1EZNMAB8vEKv/d3e9097tSSljnTwAmQOMBVF/MnVdp9Ql302q1nmVmW4rI80XkBSLyjMpDXO7ut4vI4pTSl0Tkl6qKy5mVMStgY3mtVmuBmb1dRHYNC8Rq8bNLzWypiADCQyKCH26q6owtz92xblYPr6fnnF+iqru6+/Yi8oR4aA+KyOVmdikPVVWXjxrxkYINyEVRvEREDlbVHcM34waWuvs1KaV/Dn+6XFWx2pGMAJ/A+5Sc8+7u/gZVnR8Pg6B6lZldKCLfH2VQHQnY4ZO3dvfj3B1LxsJ+jiW1Wq0rxsfHfxpuY2QAd3tqATzxgpV2kIjsHiuNjOZTZvYPIvIzVcW1DXUMFexI3TbKOf+tiLyDDIOJi8gFZnZJ3MSs+cheSBFDWq3W1mZ2qIjsFSvvbnc/M6V0o6qSxQxtDA1sUriiKHYxs5PdneCED1xsZh8b9fIcFA13x4/v5O4nuDtBlbixuNlsLpw3bx6uZSgrcChgu/v6Oed3icjhkYrdKSILU0pfVdWHBwVjNt4fq3LDnPPbRIR7eYqIkB2dlFL64jB8+cBgL1++fIuxsbHTYxliEZ82sw+HyxiKRcwG2OV3uDvV6TZFUXxQVV8sIgT0M83sfFX9zSBzmTHYYQkLiqI4R1UXiMgydz85pXStqpIbP6qHu2+ccz5ORLB0cvhLzOwUVSVdndGYEdgA3Wq1djaz80RkC3f/VkrpSBG5Y5D8eEZ3MMI3EUCLoni9qp5BsFfVz6rq0apKsdX36BtsgC6KYndVBehNVPXLqnqEqt7f97c/Ct7g7qkoileq6tlxv/jvw1X1gX6n3zfYzWZzVzP7JGWwu1P2Hquqy/r94kfT9bGSdzKzj4vIlqpKWnioqlIv1B59ge3uL845ky8/U0SuNrMjB/FhtWe5GlwYMWo7d7/Q3bdQ1SWqepiqUqzVGrXBdvetiqK4RFW3VdXPqeo7VRUGba0a7r5jGNzTo1hjZdfKUmqB7e5PLYriQlWFV7glpXSgqv5wrUI5bjYsfO+cM64UavdkMzu7Th7eE2x3f3zO+TQRIQjep6pvUtV/WxuBLu8ZfqUoigMiaK509wMbjcYNvTBZJdiReZD6nE8J6+5vbTQaX+j1oWvD38MIT8UI6QaZ2atV9QeruvdVgr1ixYotG43GZ0VkMxE51cw+Ume5rA1gc4+4V3e/wt13iqKHlLAredUVbMiZqA7fqqrkliwbaMjHRgWBlStXbpdSup6mhLu/PaX0mW7EVUewIwjsm3O+iEZpznmfsbExiP7HxhQE4O6jrH+/iNxrZhRAHeuObmBvWBQF6d22IvKR4ARWGx56dXvi7v60wAtqGdLq7zq522lgU57mnA8WkY+KyA/MbI81vUIcxsNz931yzvQzf2dmL6N5PfVzO4ENp0sDFoLpsJQShczQW0TDuMHV6TOIce5+MaCLyHlm9p6pTeRJYLu7FUVBwXKuu383pYT/eSwo1nyq7v7ynPNi+qtmtvNU654K9vrufqO7z3f3Q1NKlz5m1TWR/v9UEMHQVdHk/pCZnVb13RNgV8rQy0Tkp2a2k6r+ov5XzfxKd0dmgICnFN50+7BSpFP9e933PDwb2hB33zPnfCWaGDPboUpUVcFeJ+r9/UTkA2ZGW4g210iHu/+RiLxPRN4UkodVfV+3Nlsv2gGB5eUicoaqIgQa2eB+iqL4kqo+z93fkVK6omyoVMHeLOdMLj1mZmjv7hnZjOKD3f1JEDkickgoVllJ3cBAIYU0gkZsOW/A5z3/G62rTlPmYfIeuv3QDqeq6v+N6t7gTXLONL4/4O5LU0pvLKvK9qSDWDlIVc9S1ZtUFcXQUDUTU28uxJAniAjtNEQ8j0R3fkkoUqe+ZX0RWSQirxSR78YftxYRuBo+o1MgRwdIdnBOCHGwcD5jYQg0R4I5fHfO+VagNbPtVfX7fFEJ9rrufrW77ywiR6EKGmUvMXQax4oIL0Cmp4fI8hBVvbbDg0GdepKIvFtEEFweGNdQ4f6piNCyopDgsyYNd39dWHT5HXwW3f8Pj8qgguq4Bsmdux+eUroYPEuwER/+CxZmZogQR+ZCYMuCKcNPY410sHcQkTeEXgNuYSKvd3fAgVkD7P8Wkb9WVayGFYlQks7RxoAtIqzMCcBJZeNzzxWRz4jILSLyIdSuLPO4fuhKAOQQOWdWGyX8dWaGET2iQaPuo6pUP/dHfjgSnxbAIfU6JSwamdpXCFyAKCLvBJQS7NBwICUAIMQ+uLovVk3X3dHqIYokm+HBXVAG9grY9A55KO8Vkd3Q9IVbYR5/32lFDOpfms3mDmaGi/uZmb1IVX8N2GQh5RK9yMyOGUWKFDsMCIRYIDwLLgFrQxTDsj5ARA4rwQ6g0HF/Im6ch7R4at4f170W0OI6NIbXcV0FbJQApLS4LTIsVhGuhx0P3DsCnKFyP+6+Qc4ZGfQfI8sbHx+/A7D5D9a0vbsfnFK6atiFTKha8bNnhrD9KBEhJWJfDDk2lluCzfc71ZiIXBytp0kW28Ev88DKFYCCCVoYWTJucn/K5wD7OAwplKykmugQEeC8R0QuGiZXH80FYgoB/Vgz+zR3hfLnWyKyXiThQ/XX4QpwEQDKzWNd8C3tHH4K2MgDqMBQWF3VzRd3WuIdfPv+qnq7uwM2Vo9lt8GO7+UBMS9WFSkkD3RiXoO6kfDbR0cNgZrqeMDeJuf8VRH5jZmxgWhoXEhY0Osj9WI3AKkePnViyVbAfjOi+dhwhEWQ1pGykRdjrT1HpJPk7eS5pIesJvbq0JylqJkAOwDHjbAiFrJPJ953NSuu55f1uCBW1V4558tV9Tuquh8ysteoKkvoTlXds+6N9ZoMVK2IAPRZUbCcyE1P9Y0BNu7ljXHtyyI7IWATP9gZUHvgFuHgReQtkX1gSGQzlNDTmLiIJTxkxKFYPdcC+Iy3mZSTdffn5Zy/ISIPtrO8oij4cLrnSyJFGTgVisC0d/hKUj2C4rmdfGL4c7IRgiOFFPIA+p7oUn5ZG+XKhe7OzjEyEObAqkB/jd9+7yrmgEyYYMn9Mxd0fQNRy+7OtpK72WRlZtsB9gdFhEh/vpmdNGhUDqBR8XOzG4nINQAdZTiVYnVgPeTR3CgZAq6GDvUxCOgjU+nFe0yLl5FxsI8SC392uAgyH+ZBHs6qqw4qS8p65gE3xG4J0lC6VTMGHJ4k5/xt9nOa2e6ATc7JjZ5hZh8dlHwKYulr4XMJPOTH3AwFRqcBmGQk5YPgAWCN/YLcCXRWSQksc8BNdCOzALW9PzO++3sisuMgxJW7r1cUBc1ySKn9AZsnvgf+LMr0gYJDlOIUEHASAEd2U1rTVADLGweULeLB0E7ium4Pp65nATw+/88CwHvj83l/p3mUq+y58YBwZW8ZpKSvlO07uPshmnO+3t13cfcjogU2UGCIKIzwkl1XlOEESMgfLLybtVJuUxli4VSESNuGYdnMg8/Fovlc3EOnwUPBoimxiWGU9VS3DwyynybAJhvZ2d3fNXSwK5EYiyKFw3cSIM/rVjRELg6PQFVJVoAYaMa+MtI6Vga+nyyIhw1R1XHVRkZCukhqSqygNTitYVt3SVUwgOCjL7mbux81MrDjhtl5RX6L4hMwSf2mMXNxLewde8vJSODTu1lhrXt2d4LzzZGJ8HkdpWFRDBEYmR966zeTBtf6kh4XRRP4svAchwP2tYH8MSklCo6B3Mi0KOX+0iCBIP5JrQB82tblsC6KC7ZcHw8nMtO5RI4PD0OmRQJAyjeN+4gcv+Rr2F4No0hePJQRYF+JPA2lAgHyAhGB8z0tpK9Db4W5+yvCpeAXuxI/FAEiQhGComg3VaUD0/dgq6CIfDkOCUDDQa47aQTQFDO4OOIJroPDA4Y2ogF8A3sr3f0AwEaMQzA4Z2o3eFjfWmHw4ChIr+AhphE/saRh40hFsbhJ3Had+USA5v2U6PArSJ0nua4KA0kxR0pIndFmCut8R91raPu5+zfdfRMz2xOwWbLwvGzbQIXZ0afW/YJu1wVPArMH01YSP0glJp124+4vFJEbg9tAhtsXt05uKyL/GEdgoOb6TnVOUbFSylPwMA8YyMuGwYd0WD1PjgqSs1G2hxtB3A6fe6uqvnaQvLLXAwmLwopKi4LanAR4dHJIG6EmaZYCfO0RzQQsGnE6p0FM0A8VoGEgYf0IijQPhspll5ONXuRtIUn7S42Owuc5NaFdv4++1Y/fJiVjRQEEgE+iNjlZJ6yTbILCotaW7Dg8BgILvTTdp4lgV6F6Ib3gawiepJi1Prv2065cGDvraHjcrap7QbFuknNmqSFhWDCT/X39TiSWOi0p+AekCxQSNEjbeXBUoVdEUQQTWUuuzG62sOivV6u/cGFQuMQnqlV4G3br1tp41O/9xT0gaaBrBMl2rZkdAdgbuPsSd+coCGjOzw9SNdWdWGQMEPcQ+GQdVG9VwKEQAPw6CKJesSSCK/w3LTIaB+3MIoCGXKKSJUuBSmCH19B4+073HO1GiC+CNbs2zgHsJ+ScyW856ORsM4OsH4kP6xBAON2MCb0azrcKeFg/IkWaCKRvd63qQUbaiPqWpsHrsNoK0FSQG4Rr4sHV3rtY13g63BuMH25sMzPbW1VvBmy2CxMkKSLoKOw1rAZCnYnixiJNo+uNuomyud3YdXcskhSOWuB93YwgAi/58t9EUKRQK5sXAA2/Td5NwOxrV26de+h0zYoVK+Y3Gg3c2W/NjL2jv2iTPbFRCS1GEX57RhvhZzoxojZHZ4gI50n9V/hyWDfSOLKRPyHoqeqPuizZzaPUpxjakxZfsI7k9ayeb/IgZmt/fRjw21R1kap+RVWhAB4uRTrwruzHfr67H5RSmiYZmCmQdd8Xp+8A+DZx9h7dErIkAhuFTqlimlThRpZBE5kMh1VB++tV0ZmBk+EgRYCetb2b0VnnXqCZT2z7a9VWCTYKHlKwsrihyz2S4qaH390uBDc0abFSqki0F4BOawvfPYmgCsKp3bCOA2bozCOg5Dw/TqtE2EO3ZNaGu28aioXHmdkuqvqvfHlVxTo/5wzrtjwUPHNy0oK70/DFT8NF4zZID3ETdM1JFyGy2mRZ+GWoBook/oYLIutg3yZHVOCjeRCzNmJPErEDF0KhSBXcVgdUwWbfI6fgcP7ekW1RyZAZwDp3XEoAQgkFTUqHhUKEshr69VVl2hbpI5UiuTM0AIUSVC3WT45LD3FWj06KhgE8C2zn0RwX0kmfTVYC84V/uU1VqcD64iXqgFnnmrBYxDVlykbAxsphBSn3S6UrbCVBkHSPlYBFlykkyqqh0sU1574g50zmszI8xERQn7qn5hk5Z5q1G5gZe9aHSjnWmWx5TfAYLEfUpnS+4cAR1TAnUkIGnXvoW/5Gl55qFHUsq3LWj3OOQgY3Rs1yqZkhx5iIfVPBZrcqgfJEd/9CSmmghmc/4HZJ6Uq5MIGbAMlAtINFM7BwRDkMXAyl8STZ8KBz6Of9VOGxrRHqg3qFlHNidNoH+cyw7vVyzvuNjY0h6Z2zEZIy+oi0rgAfiy2ZQEr6ctcClejps1mQVUGhGZFzhk0kk7teVXHJk3ZvdAJ7Xs4Z6pFzVP8ppcSWj5Fu+un1JEOLUlIKUKOlL6ZKJO9Gn33CXM4THj7nTLBmQ8G+qoo7njQ6ygXcnTOucfJkA3OWmUyxHEpu/CH+GuUUA5YQv003ZkZStV4Pus7f4XHc/SJ33zeOwuDsqGkyvm5gQw+S38L5LmtLp3ocXFJnUoNe4+5UhGj2KMkZWBI3NmdnVcWu6Da3RGFVFMUe4+PjHavVrkIYd+c3CMq8+xNmhtx2YNHlEABHuwcfzSDar/L0mkG/r9f73X1zd/9c8DunxAE4HZvmq1Qd0THJObNM58XBJfDNs1okdLrZCJoyV8GwnFPQ0xRTkE7faGuwV+HOeoFdHlyC/ODHZgZPjOBwrR/B7JFxEEegUcEG2VrX0VNPhzuJgwPJGzkKlC8YSK20JjypZrPJCZaovdrbwTmXtpcCuCfYAOPuz805o3Zt6/fMjLZSXzsC1gSAK+4DKvpScCHtNDMOw+3Zz6wFNl/SbDZ3ix9hoL10lpnNWQExlw9u+fLlz2k0Gsj02JzLYeys9FrZUG2wI8WhwKGpihTg9JCrjUwKMJegdgnMm7J5QFXZNvg9M0MbWO6j7znd2mCHOyFgwh9DDlG9LTQz9srU2s3Vczar8QUUeu6+yN0RD3FoIhlIX02JvsAOwOEA4Iop6WHhOA+JczzWWB/u7n9eFAVGxbaPe4uiOGRsbKxvtWvfYAfg/HIHTUwqTErVy1NKJ65pWUoIQl9YFMXH+YE5EbkLQ5vpGYczAjsA5/BXGgwQ/BtFsICevWvYatC58C5w00VRoPeAANvE3W/NOb97fHy83U+cyZgx2AG4tVotfpsGWRdp0APu/v6UEu2oR23gpImcc0YSR8MZV3m9mSGo7yilqAv8QGAH4HwGv994Roje4ZuvbDabi+bNm/fDUUhx695cv9dhza1W66WqiiCITj98NGku/nrgmDQw2JVEnx8GQsmPZo+qCuXRx8wM+S6/6TjnnEo38EOmtjluInQqNCnuiR8EWjqsFtvQwC5TQxHht2uOZzsa3Xva+TnnRSklWkT8EOZqA3qAzLkg5Sk+aE2oBPlhIxrJy4Y536GCXbFyjltDWM8REHS9+T3dm1UVlVAJ+kCbW/t1EdXrYz8NIHN4DKcysH0QbeHX3H1ho9G4fRTi0pGAHVZO0YMyiGMoeFHmc2T9PZwpYmYQ/wgp+YXToe5l6VL90U5bp9lsbpVSomGMcpZOVEasnnM+LwL7yFqAIwO7YuVEcwT3aL/ZU8MNMqg6vx5dfMTuAN/+ZelhLN3QnvDd7Bp+Vs6Z7XGcLVv+6GYL/R9nhKeUePDElZHqTEYOdgV0uuAbFEWBvIwzTji5jECED1/h7vezw8Ddb8s53zc2NoaUjI4H7gYQyqNBy1XA3MsXu3lZSfQmH99qtdBEA+qL4sUhilg2n4GI54ac85JGo8GJb8SRkYJcYjBrYFdABxiILI63Q0r2CvQWATzzAUwAxsJ/knP+UZwJS95OKsarPEGBz0F69iRV3djdiQ9PDWABn88DSNK2W2hfpZTQTGPFI//N3qnubNbBnhKosDaWOf5825wze3rgivl16fL4iuoc+Xdp4aVVV7Ob8kGxs4DTIO4wM1SwbDrlYc1KfOgWvOcU7CnAY/EA3341m82NzIwfiiMd42GgfCJ/57oSYHw8Ae1X7v5zd1/WaDTI79kvw1YVwJ2VLSt1sqM/AFhRxDHFyoeAAAAAAElFTkSuQmCC"
                                alt
                            />
                            <p class="internet-icon-title">统一服务场景</p>
                        </div>
                        <div class="internet-app-text">
                            <div class="internet-text-title">统一服务场景</div>
                            <div class="internet-text-br"></div>
                            <div class="internet-text-work">基于企业需求，按需集成软件系统，通过单点登录，形成统一一体化服务场景</div>
                        </div>
                    </div>
                </div>
                <div class="internet-app-item internet-app-item3">
                    <div class="internet-app-mark"></div>
                    <div class="internet-app-content">
                        <div class="internet-app-icon">
                            <img
                                src="data:image/png;base64,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"
                                alt
                            />
                            <p class="internet-icon-title">数据互通场景</p>
                        </div>
                        <div class="internet-app-text">
                            <div class="internet-text-title">数据互通场景</div>
                            <div class="internet-text-br"></div>
                            <div
                                class="internet-text-work"
                            >通过数据采集分析，打破信息孤岛，汇聚成工业大数据，为政府决策提供依据，为企业、行业、产业提供有价值的数据分析服务，实现数字“新基建”。</div>
                        </div>
                    </div>
                </div>
                <div class="internet-app-item internet-app-item4">
                    <div class="internet-app-mark"></div>
                    <div class="internet-app-content">
                        <div class="internet-app-icon">
                            <img
                                src="data:image/png;base64,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"
                                alt
                            />
                            <p class="internet-icon-title">协作场景</p>
                        </div>
                        <div class="internet-app-text">
                            <div class="internet-text-title">协作场景</div>
                            <div class="internet-text-br"></div>
                            <div
                                class="internet-text-work"
                            >通过数字化管理，生产智能排产、设备数据采集，可实时监控车间生产过程及设备运行状态，人、机、物的高效协同，实现车间数字化，便于工业企业管理层决策。</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="internet-platform">
            <div class="w-1200-c">
                <div class="platform-text">
                    <p class="title">轻应用开发平台</p>
                    <p
                        class="desc"
                    >为项目提供多种开发工具，实现低成本、高便捷的应用搭建方式 提供覆盖主流开发语言环境的线上IDE全代码开发环境，与组态设计器 基于 DevOps流水线测试，发布，部署。</p>

                    <router-link to="/lightapplication" target="_blank">
                        <div class="btn">查看更多</div>
                    </router-link>
                </div>
            </div>
        </div>

        <div class="internet-center">
            <div class="w-1200-c">
                <div class="common-top">
                    <p class="common-title">工业大数据中心</p>
                    <p class="common-desc">汇聚成工业大数据，为政府决策提供依据，为企业、行业、产业提供有价值的数据分析服务，实现数字“新基建”。</p>

                    <router-link to="/industData" target="_blank">
                        <p class="common-btn">查看更多</p>
                    </router-link>
                </div>
                <div class="center-content">
                    <div class="t1-warp">
                        <div class="t1-block">
                            <img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAADOUlEQVRIS63XaaimYxgH8N8IIVJoyL5E1EyJopR8IVnDB0pkn2Ys2ZVlxk627EuDGZQPiiKZmSxFiigJZU9ZkizZQtbRX9dTzzze93ne83buOp3Oc1/X9b+v/X/mmPxsh/nYGN/iLXw1ufqaknMGFANyBk7Ezh3Zf/A2Hqyf32byiD7gY3A3Ni2Df+BrbI3PsCXWrrtPcRqemxR8HPCNuLCMxKvr8Az2wEvYET/gWFyA7fE3LsZNk4CPAr4SS7AalxdojObshxexEz6pb+vjFiyqvxfg/iHwLvAheLqUTsWyjoFRwI3I1bgMSck+eKMPvA28AT6oHN6K80Yo9gFH/AkchTexZ0VtJH4bOLlKflI4u+HXKYA3r8enG47Ek+O8bgN/WC2T9rlnjMKQx1FLIabIXsD+Q8C7V3hSRGmLn8coJBJX4XR8M0ZmW9yMv5AIfD9KrvH4LNwxVIlT3B/eKtY11Bvge7Gw8vP5FABdlUy5jNhLK/T/M9kAN9WYMD8wC8BNa2XyndkX6lU4EMfh0VkAvgg3YDlO7gNuPD5lxNCY5h1X1NQb9LjJ8TVYPA1SR+chnIBLcH2fx8nDnViJg2cB+B3Mw6G1XMYWVxZ8ttAv1Xv5Pe1JRWf0/om5+LHP49y9W6Oyb3JN8pgUVYrr2SrYwVl9Nm6rWb0rZsQoyvpWeB8b9oU5su1ZvR7eq6WeKZaHzOTEVsjCQXgde/cpd/fxAUhP53uAU3CTnmy2bLjfsVfVzFjdUQyk6cEwkGtrKaRQxp2ENRE6qQSmYiCN8QCmB5uiCwd7qnhWI7MFji4vt6kqPrcIYmSymTZDZv9P3VcPscy7Sjl68TpsMkY2QdbfWmXwY2TqvVwM5PzKce5DKO4rR5KG/84Qr96oeHWm0C4toOhmd7+GR/BwMdCEPJSnuQ/xj+c5K3BEOTAI3I5QNtfS4lEhAym877BDzeXj62GhvbfXlvsCh+ExhI3m+zmTeNwGTtiS54zBFN5HxSjT8yH2+c8inoeP50HtEwL4eH3ISF41FOpuTaxbhDAcep26DGC4dpbLK12F1t9ZQGGuYSXPzxS4sZO87Vuev4ovewDbV3l4eLd/AdAJsh8nsUqAAAAAAElFTkSuQmCC"
                            />
                            <span>易于访问</span>
                        </div>
                        <div class="t1-block">
                            <img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAACyUlEQVRIS+3XS8jVVRQF8N83yCa9NUIbCJUNMksRyQittEHzLIiiyAblY2goBpVCodRQewwyjCKonDuwtCQqIspeg9LAgUr00mpSDor1sQ/87+Ve74fdDyee6f/89zp7n732WmfCOVoTfbgLsRm34yIcxuvYgb+neMYLsR4P4Tr8hQ/wHL5sMbrAq/EyLsAP+BU31gE+x104OQL8MuzD4gL8BjMxD6fxOHYlRgNehE/wCx7AgQK4BNvrh3dx7wjgd7CqEtiIP2r/HXgTs7AUXzTg9kNK/OGA4O9hRVXg2yHg85EM38fKAXuWV8knE2jAP9XpUpJBK1V4A+vw4pA9a7ETD1Z2g7blClPFqxpwGuBr3DokaEq1H09j65A9T2EL7uxcVf/Wj7EgfdOAD+EazMGfAwLnCnLvz1TwQdg5VL7nkOni/nUxjuNH3NyAN+D5aoo10wT8UjXpE3ihAYd7HxUNUtJXcQz/1iFCq3A5VAivB63wNpQMh9NkjTVX49G6gtDytsyELo8vxytFh/7BMoJFIz8ngXTzY/i9naj/r9AidxrOtQPMxSNFlUF0S4zQJZR7DUcraAAzG3LnPTScambjaK6eBM8DD+uS86U+m8k1srluKDpdOSY6/Vx0+q6L3O3qK2qA3NMBHDkZprghfN5TA+S37gDJyDyIJaVC0zUyP8Oy7shsIpFBHs1tM7ol9H+7OpWNVkeAekTiq5LF2dMsiydKFm8650Yg1ucUrh/SLOOyPt/j0q71ebsc5DD3EAMXSxPl6qFF56ChYRQoeh6V6l+tT2Is7+va208Rzt3fcZoxZtuqKUKHWNczrWhu6Jgm3dSxt5HMt5DZcEvX3iZY3EN+mFEviOhoM/Shwd2Y5OAZVmbB3qJlDGScSHQ9L4p/KoEeQ99i5QnzZIl6njBHsPssnzAP49p6UcQ8PDvsCTPFITSebf8B5o7LH4kAJhAAAAAASUVORK5CYII="
                            />
                            <span>可扩展性</span>
                        </div>
                        <div class="t1-block">
                            <img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAABg0lEQVRIS+3WvUodQRjG8Z8fqIVFQBCiCEZSSECw1iLRWGlryE14A95AmtQSsAzEq9AEREFIkypEUCR+QQixCFYxifLiLqzLHjPLOZLCM+0+M/95n31nnulAF4bRIW2c4iJN2lgVsA3M1lhoFxPNwgMcu/+NnQT4JB5gFF8T9A0lOfgIYwkLvcdMK8HHeNQA3I1VDKEXz0rgaTxO2HRR8jmvOMBPs0Y7KCgCuoYX+IJvmS63OjbyEz01wWc5eC+bOIJ5bKII3c8sfltR8UuM1wR/ysGHeIPXOMcClrJKc2j0wYcKcE3mtbxodfzjZbzCn8z2IjT0dwaOxXN4GXrn4ABMIS6KHyUfqypewZOafn9s9hxHV0d/DNYEHwT4Fy5x8o/7OjQP0Vc6x/0YqAn+HuB3WERnwuSAb+M5/ibob70y42MkVEo6BTg6vukRsP8Wi+uZdalVtGMx1akbuvKVWbVIOxbLD4F2LCY1W1VztWOxaF35eXs/YnELc62KxaRObKXoCsvbp+WpsjveAAAAAElFTkSuQmCC"
                            />
                            <span>灾难恢复</span>
                        </div>
                    </div>
                    <div class="bdp-bg">
                        <div class="t2-warp-bg">
                            <div class="t2-warp">
                                <div class="t2-block">通过供应商的 API 或 Web 界面，用户几乎可以随时随地访问云数据库。</div>
                                <div class="t2-block">云数据库可以扩展运行时存储容量，以适应不断变化的需求。企业仅需按使用付费。</div>
                                <div class="t2-block">出现自然灾害、设备故障或停电状况，就会在远程服务器上备份数据，保证数据安全。</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            scrollTop: 0,
        };
    },
    mounted() {
        let _this = this;
        window.addEventListener("scroll", this.handleScroll, true);
    },
    methods: {
        handleScroll: function (e) {
            let _this = this;
            _this.scrollTop = document.documentElement.scrollTop;
            _this.getBottomOfWindow();
        },
        getBottomOfWindow: function () {
            var winHeight = window.innerHeight;

            var appTop = $(".app-top").offset().top; //
            if (appTop <= this.scrollTop + winHeight * 0.8) {
                $(".app-top").animate({ opacity: 1, top: 0 }, 800);
                $(".internet-app-warp").animate({ opacity: 1, bottom: 0 }, 800);
            }

            var centerTop = $(".internet-center").offset().top; //数据中心
            if (centerTop <= this.scrollTop + winHeight * 0.8) {
                $(".internet-center").animate({ opacity: 1, top: 0 }, 600);
            }
        },
        toUrl(url) {
            if (!url) {
                return;
            }
            this.$router.push({
                path: url,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.internet-content {
    // 公共样式
    .w-1200-c {
        width: 1200px;
        margin: 0 auto;
    }
    .w-1500-c {
        width: 1500px;
        margin: 0 auto;
    }
    .common-top {
        text-align: center;
        padding-bottom: 40px;
        .common-title {
            font-size: 34px;
            font-weight: 400;
            color: #0b1d30;
            line-height: 40px;
            letter-spacing: 3px;
            margin-bottom: 30px;
        }
        .common-desc {
            font-size: 16px;
            font-weight: 300;
            color: #757f92;
            line-height: 19px;
            margin-bottom: 30px;
        }
        .common-btn {
            width: 140px;
            height: 40px;
            background: #1f51c8;
            font-size: 14px;
            font-weight: 300;
            color: #ffffff;
            line-height: 40px;
            margin: 0 auto;
            cursor: pointer;
        }
    }

    // banner
    .internet-banner {
        height: 540px;
        width: 100%;
        // background-image: url("https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/industInternet_banner.jpg");
        // background-image: url("../../assets/home/industInternet_banner.png");
        background: url('../../assets/fixpage/industlot/banner.jpg') center no-repeat;

        background-repeat: no-repeat;
        background-position: top center;
        background-size: cover;
        padding-top: 185px;
        box-sizing: border-box;
        background-color: #eee;
        .banner-text {
            padding-left: 90px;
            .s-title {
                font-size: 16px;
                color: #000000;
                line-height: 19px;
                letter-spacing: 1px;
                margin-bottom: 22px;
            }
            .title {
                font-size: 42px;
                font-weight: bold;
                color: #252d3d;
                line-height: 49px;
                letter-spacing: 4px;
                margin-bottom: 10px;
            }
            .line {
                width: 320px;
                height: 8px;
                background: #1f51c8;
                margin-bottom: 22px;
            }
            .desc {
                font-size: 15px;
                color: #252d3d;
                line-height: 28px;
            }
        }
    }

    .internet-one {
        padding: 90px 0;
        background: #f8fcfe;
        .internet-one-image {
            height: 600px;
            background: #eee;
            margin: 0 auto;
            background: url("https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/pic_2.png") no-repeat;
            background-size: cover;
            position: relative;

            .item-absot1 {
                top: 100px;
                left: 245px;
            }
            .item-absot2 {
                top: 430px;
                left: 443px;
            }
            .item-absot3 {
                top: 172px;
                right: 32px;
            }
            .itp-warp-item {
                position: absolute;
                height: 108px;
                width: 348px;
                .itp-warp-animat {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 71px;
                    height: 71px;
                    background-image: url("https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index/news_bg/itp-icon-gif.png");
                    background-repeat: no-repeat;
                    animation: myAnimation 1.27s steps(1) infinite;
                }
                .itp-warp-content {
                    position: absolute;
                    left: 40px;
                    width: 238px;
                    .itp-warp-item-img {
                        text-align: left;
                        width: 100%;
                        height: 39px;
                        margin-left: 34px;
                        background: linear-gradient(
                            90deg,
                            #fff 0,
                            hsla(0, 0%, 100%, 0)
                        );
                        .itpImg {
                            padding: 5px 14px;
                            vertical-align: top;
                        }
                        .itpspan {
                            font-size: 20px;
                            font-family: "PingFang SC";
                            font-weight: 700;
                            color: #333;
                            letter-spacing: 1px;
                            line-height: 39px;
                        }
                    }
                    .itp-warp-item-bg {
                        width: 100%;
                        height: 35px;
                        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAO4AAAAjCAYAAACTmDZIAAABeElEQVR4nO3dQUrDQBQG4FfxDt6hHkQvoHfwHN5GF7p24ym8he7ciSiFZqGk2kwm8ybwfVCaptPmUfjJTwnt5uzyM37YxLix/cfsO27NNiJeRp//7/0OrS1Z12p7ynFqrs06bi/bf80x5bmSx2OvmbLv19qTA0tau+pkDliF006GHIJ7ERFPybNAMzfvt0WH6uGMu6vJ5xHxFhHPHcwD3eshuMPZ9jEiPpJngVXoKbh3yXPAamQHV02GAtnBVZOhQC/BVZNhgszgqslQKDO4w9n2QU2GaXoI7n3iDLBKWcFVk2GGrOCqyTBDdnDVZCiQEVw1GWbKCK6aDDNlBldNhkKtg6smQwWtg6smQwVZwVWTYYaWwVWToZKWwVWToZKWwb3e36vJMFOr4G73t1c1GeZrFVy/dAEVtQqumgwVtQiumgyVtQiumgyVtQiumgyVLR1cNRkWsHRw1WRYwNLBVZNhAbu/2fxa+IN1bTJU1uLLKdcmQ00R8Q1gpjzMnLG+ZQAAAABJRU5ErkJggg==);
                        background-repeat: no-repeat;
                    }
                }
            }
        }
    }

    .internet-app {
        background-color: #eee;
        background: url("https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/industInternet_pic_2.jpg") no-repeat;
        background-position: center;
        background-size: cover;
        .common-top {
            padding: 90px 0 0;
            padding-bottom: 112px;
        }
        .app-top {
            position: relative;
            top: -35px;
            opacity: 0;
        }
        .internet-app-warp {
            display: flex;
            min-width: 1200px;
            position: relative;
            bottom: -35px;
            opacity: 0;
            .internet-app-item {
                width: 25%;
                height: 720px;
                position: relative;
                cursor: pointer;
                .internet-app-mark {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: rgba(0, 9, 38, 0.75);
                    transition: all 0.4s ease;
                    transform: rotateY(0);
                }
                .internet-app-content {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 80%;
                    height: 370px;
                    .internet-app-icon {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 80%;
                        img {
                            display: block;
                            margin: 0 auto;
                            margin-bottom: 20px;
                        }
                        .internet-icon-title {
                            margin-bottom: 0;
                            font-size: 24px;
                            color: #fff;
                            letter-spacing: 2px;
                            text-align: center;
                        }
                    }
                    .internet-app-text {
                        transition: all 0.36s ease;
                        transform: rotateY(90deg);
                        background-color: #263050;
                        position: absolute;
                        height: 100%;
                        width: 100%;
                        padding: 12%;
                        box-sizing: border-box;
                        .internet-text-title {
                            font-size: 26px;
                            font-family: "PingFang SC";
                            font-weight: 500;
                            color: #fff;
                            letter-spacing: 2px;
                            text-align: left;
                            margin-bottom: 25px;
                        }
                        .internet-text-br {
                            width: 58px;
                            height: 3px;
                            background: #fff;
                        }
                        .internet-text-work {
                            margin-top: 40px;
                            width: 100%;
                            font-size: 18px;
                            text-align: left;
                            color: #fff;
                            line-height: 30px;
                            letter-spacing: 1px;
                        }
                    }
                }
            }
            .internet-app-item1 {
                background: url("https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/industInternet_pic_3.jpg")
                    no-repeat;
            }
            .internet-app-item2 {
                background: url("https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/industInternet_pic_4.jpg")
                    no-repeat;
            }
            .internet-app-item3 {
                background: url("https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/industInternet_pic_5.jpg")
                    no-repeat;
            }
            .internet-app-item4 {
                background: url("https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/industInternet_pic_6.jpg")
                    no-repeat;
            }
            .internet-app-item:hover {
                .internet-app-mark {
                    transition: all 0.8s ease;
                    display: none;
                }
                .internet-app-icon {
                    transition: all 0.36s ease;
                    transform: rotateY(90deg);
                }
                .internet-app-text {
                    transition: all 0.36s ease;
                    transform: rotateY(0);
                }
            }
        }
    }

    .internet-platform {
        height: 390px;
        padding-top: 90px;
        box-sizing: border-box;
        background-color: #eee;
        background-image: url("https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/industInternet_pic_7.jpg");
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        .platform-text {
            padding-left: 60px;
            .title {
                font-size: 34px;
                font-weight: 400;
                color: #0b1d30;
                line-height: 40px;
                letter-spacing: 3px;
                margin-bottom: 17px;
            }
            .desc {
                width: 466px;
                font-size: 16px;
                font-family: Microsoft YaHei UI-Light, Microsoft YaHei UI;
                font-weight: 300;
                color: #757f92;
                line-height: 30px;
                margin-bottom: 28px;
            }
            .btn {
                width: 140px;
                height: 40px;
                background: #1f51c8;
                font-size: 14px;
                font-family: Microsoft YaHei UI-Light, Microsoft YaHei UI;
                font-weight: 300;
                color: #ffffff;
                line-height: 40px;
                text-align: center;
                cursor: pointer;
            }
        }
    }

    .internet-center {
        padding: 90px 0 160px;
        // background-color: #f2f5fa;
        position: relative;
        top: -35px;
        opacity: 0;
        background-image: url("https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/image/industInternet_bg_1.jpg");
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        .common-top {
            padding-bottom: 50px;
        }
        .center-content {
            .t1-warp {
                background: #fff;
                width: 1182px;
                height: 84px;
                display: flex;
                margin: 40px auto 0;
                align-items: center;
                text-align: left;
                .t1-block {
                    width: 394px;
                    display: flex;
                    align-items: center;
                    img {
                        margin: 0 16px 0 28px;
                        width: 30px;
                        height: 30px;
                    }
                    span {
                        font-size: 22px;
                        font-weight: 700;
                        color: #333;
                        letter-spacing: 1px;
                    }
                }
            }
            .bdp-bg {
                .t2-warp-bg {
                    height: 178px;
                    width: 1180px;
                    border-top: 1px solid #e9e9e9;
                    margin: auto;
                    .t2-warp {
                        text-align: left;
                        display: flex;
                        background: #fff;
                        .t2-block {
                            width: 394px;
                            height: 150px;
                            padding: 25px 28px;
                            font-size: 16px;
                            letter-spacing: 1px;
                            transition: all 0.3s;
                            background: #fff;
                            cursor: pointer;
                            box-sizing: border-box;
                            font-size: 16px;
                            font-family: Microsoft YaHei UI-Light,
                                Microsoft YaHei UI;
                            font-weight: 300;
                            color: #757f92;
                            line-height: 30px;
                        }
                        .t2-block:first-child:hover {
                            z-index: 2;
                            box-shadow: 2px 2px 10px 10px
                                rgba(68, 127, 203, 0.2);
                            background: url("https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index/news_bg/1.png")
                                no-repeat center;
                        }
                        .t2-block:nth-child(2):hover {
                            z-index: 2;
                            box-shadow: 2px 2px 10px 10px
                                rgba(68, 127, 203, 0.2);
                            background: url("https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index/news_bg/2.png")
                                no-repeat center;
                        }
                        .t2-block:last-child:hover {
                            z-index: 2;
                            box-shadow: 2px 2px 10px 10px
                                rgba(68, 127, 203, 0.2);
                            background: url("https://oss-zlwl-sy.oss-cn-beijing.aliyuncs.com/zkwl/index/news_bg/3.png")
                                no-repeat center;
                        }
                    }
                }
            }
        }
    }
}

@keyframes myAnimation {
    0% {
        background-position: 0 0;
    }

    2.63% {
        background-position: -71px 0;
    }

    5.26% {
        background-position: -142px 0;
    }

    7.89% {
        background-position: -213px 0;
    }

    10.53% {
        background-position: -284px 0;
    }

    13.16% {
        background-position: -355px 0;
    }

    15.79% {
        background-position: -426px 0;
    }

    18.42% {
        background-position: -497px 0;
    }

    21.05% {
        background-position: -568px 0;
    }

    23.68% {
        background-position: -639px 0;
    }

    26.32% {
        background-position: -710px 0;
    }

    28.95% {
        background-position: -781px 0;
    }

    31.58% {
        background-position: -852px 0;
    }

    34.21% {
        background-position: -923px 0;
    }

    36.84% {
        background-position: -994px 0;
    }

    39.47% {
        background-position: -1065px 0;
    }

    42.11% {
        background-position: -1136px 0;
    }

    44.74% {
        background-position: -1207px 0;
    }

    47.37% {
        background-position: -1278px 0;
    }

    50.00% {
        background-position: -1349px 0;
    }

    52.63% {
        background-position: -1420px 0;
    }

    55.26% {
        background-position: -1491px 0;
    }

    57.89% {
        background-position: -1562px 0;
    }

    60.53% {
        background-position: -1633px 0;
    }

    63.16% {
        background-position: -1704px 0;
    }

    65.79% {
        background-position: -1775px 0;
    }

    68.42% {
        background-position: -1846px 0;
    }

    71.05% {
        background-position: -1917px 0;
    }

    73.68% {
        background-position: -1988px 0;
    }

    76.32% {
        background-position: -2059px 0;
    }

    78.95% {
        background-position: -2130px 0;
    }

    81.58% {
        background-position: -2201px 0;
    }

    84.21% {
        background-position: -2272px 0;
    }

    86.84% {
        background-position: -2343px 0;
    }

    89.47% {
        background-position: -2414px 0;
    }

    92.11% {
        background-position: -2485px 0;
    }

    94.74% {
        background-position: -2556px 0;
    }

    97.37% {
        background-position: -2627px 0;
    }

    100.00% {
        background-position: -2698px 0;
    }
}
</style>
